﻿const axios = require('axios');
const dutchMonths = new Map([...Array(12)].map((x, i) => [new Date(2022, i, 1, 0, 0, 0, 0).toLocaleDateString('nl-NL', { month: 'short' }).slice(0, 3), i]));

const defaultApp = {
    data() {
        return {
            generalError: false
        }
    },
    methods: {
        async fetchData(data, apiUrl, method) {
            try {
                const response = await axios({
                    method: method,
                    url: apiUrl,
                    data: data,
                    headers: { "Content-Type": "application/json" },
                })
                return response;
            } catch (error) {
                console.log(error);
                this.generalError = true;
            }
        },
        getDateFromString(dateString) {
            if (!dateString.length) return new Date()
            const i = dateString.split('-');
            let dt = new Date(i[2], dutchMonths.get(i[1].slice(0, 3)), i[0]);
            return new Date(dt - dt.getTimezoneOffset() * 60000)
        },
        toEuro(number, symbol = false) {
            if (number === null) return '---';
            if (isNaN(parseInt(number))) return null;
            let amount = Number(number).toLocaleString('nl-NL', {
                style: 'currency',
                currency: 'EUR',
            });
            return symbol ? amount : amount.replace('€', '').trim();
        }
    }
}

export default defaultApp;